export default __webpack_public_path__ + "static/media/type_11_8.e9811892.svg";